module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"docs":"Docs","forum":"Forum","version":"Version"}}')
  delete Component.options._Ctor
}
